import { render, staticRenderFns } from "./LoansReportModal.vue?vue&type=template&id=50cf0ae9&scoped=true&"
import script from "./LoansReportModal.vue?vue&type=script&lang=js&"
export * from "./LoansReportModal.vue?vue&type=script&lang=js&"
import style0 from "./LoansReportModal.vue?vue&type=style&index=0&id=50cf0ae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf0ae9",
  null
  
)

export default component.exports